module.exports = __webpack_public_path__ + "img/suit-05.17229c2d.png";